import AbstractFormulaToken from "./AbstractFormulaToken.js";

/**
 * Token representing an opening parenthesis.
 *
 * Parenthesis are used when parsing a list of tokens to determine operator
 * precedence.
 */
export default class OpeningParenthesisFormulaToken extends AbstractFormulaToken {
	isOpeningParenthesis() {
		return true;
	}

	accept(visitor) {
		return visitor.visitOpeningParenthesisFormulaToken(this);
	}

	static getLabel() {
		return "Opening parenthesis";
	}

	static getType() {
		return "opening-parenthesis";
	}
}
